import { FaArrowLeft } from "react-icons/fa6";

export default function ArrowLeft({size}) {
    return <FaArrowLeft size={size} />;
}